import { render, staticRenderFns } from "./main.vue?vue&type=template&id=437121a2&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('437121a2')) {
      api.createRecord('437121a2', component.options)
    } else {
      api.reload('437121a2', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=437121a2&", function () {
      api.rerender('437121a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DwElImage/src/main.vue"
export default component.exports